import { render, staticRenderFns } from "./newOrder.vue?vue&type=template&id=79557b9c&scoped=true"
import script from "./newOrder.vue?vue&type=script&lang=js"
export * from "./newOrder.vue?vue&type=script&lang=js"
import style0 from "./newOrder.vue?vue&type=style&index=0&id=79557b9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79557b9c",
  null
  
)

export default component.exports